import { Link, useNavigate } from 'react-router-dom';
import { Box, Button, Card, CardContent, CardHeader, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, useTheme } from '@mui/material';
import SearchIcon from '@mui/icons-material/SearchOutlined';
import { tokens } from '../../theme';
import { IDoctor, IPrescription, doctorsBaseRoute } from "../../types";

interface RecentDoctorsProps {
  prescriptions: IPrescription[];
}

const extractDoctors = (prescriptions?: IPrescription[]): IDoctor[] => {
  if (!prescriptions) {
    return [];
  }

  return prescriptions
    .map(rx => rx.doctor)
    .filter((doctor, index, array) => array.findIndex(x => x.id === doctor.id) === index);
};

const DashboardRecentDoctors = ({ prescriptions }: RecentDoctorsProps) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const navigate = useNavigate();
  const doctors = extractDoctors(prescriptions);
  const total = doctors?.length;

  return (
    <Card sx={{
      backgroundColor: colors.primary[400] 
    }}>
      <CardHeader 
        title={
          <Typography 
            variant="h5" 
            fontWeight="bold" 
            color={colors.greenAccent[500]}
          >
            Doctors Count: {total}
          </Typography>
        } 
      />
      
      <CardContent>
        <div style={{ width: '100%', height: 300 }}>
          <TableContainer 
            sx={{
              width: '100%',
              height: 260
            }}
          >
            <Table stickyHeader={true}>
              <TableHead>
                <TableRow>
                  <TableCell>Full Name</TableCell>
                  <TableCell align="right">License #</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {doctors.map((doctor: IDoctor) => (
                  <TableRow key={doctor.id} hover onClick={() => navigate(`${doctorsBaseRoute}/${doctor.id}`)}>
                    <TableCell>{`${doctor.firstName} ${doctor.lastName}`}</TableCell>
                    <TableCell align="right">{doctor.licenceNumber}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          <Box 
            sx={{
              marginTop: '8px'
            }}
          >
            <Button
              sx={{
                backgroundColor: colors.blueAccent[700],
                color: colors.grey[100],
                fontSize: "14px",
                fontWeight: "bold",
                padding: "8px 14px",
              }}
              component={Link}
              to={doctorsBaseRoute}
            >
              <SearchIcon sx={{ mr: "8px" }} />
              Search All Doctors
            </Button>
          </Box>
        </div>
      </CardContent>
    </Card>
  );
};

export default DashboardRecentDoctors;